/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import React, { FC, ReactNode, useCallback } from 'react';
import { Root, createRoot } from 'react-dom/client';
import { CalendarProps, CalendarPropsContext } from '@progress/kendo-react-dateinputs';

// Для вставки элемента React 18
// https://react.dev/blog/2022/03/08/react-18-upgrade-guide#updates-to-client-rendering-apis

export function imRender(element: ReactNode, container: Element | null): () => void {
    return render(<Wrapper>{element}</Wrapper>, container);
}

export function render(element: ReactNode, container: Element | null): () => void {
    if (!container) {
        // eslint-disable-next-line no-console
        console.warn('Не задан контейнер для функции render', element);
        return () => {};
    }

    const anyContainer = container as any;

    if (anyContainer.timeout) {
        clearTimeout(anyContainer.timeout);
        anyContainer.timeout = undefined;
    }

    const createdRoot: Root = anyContainer.reactRoot ?? createRoot(container);

    anyContainer.reactRoot = createdRoot;

    createdRoot.render(element);

    return () => {
        anyContainer.timeout = setTimeout(() => {
            createdRoot.unmount();

            anyContainer.reactRoot = undefined;
            anyContainer.timeout = undefined;
        }, 0);
    };
}

const Wrapper: FC<{ children: ReactNode }> = ({ children }) => {
    // https://bugbase.dev.imdomain/#object=2193451 WebInterface. Файловые шкафы. Неправильно работает выбор месяца при фильтрации списка файлов по датам
    // проблема связана с ошибкой в пакете @progress/kendo-react-dateinputs см. https://github.com/telerik/kendo-react/issues/1566
    // предложенное решение https://www.telerik.com/forums/disable-calendar-fast-navigation-bar-globally
    // в 10 версию не переносится, т.к. ошибка исправлена в новых версиях пакета
    const calendarProps = useCallback(
        (props: CalendarProps): CalendarProps => ({
            ...props,
            navigation: false,
        }),
        []
    );

    return (
        <CalendarPropsContext.Provider value={calendarProps}>
            <LocalizationProvider language="ru">
                <IntlProvider locale="ru">{children}</IntlProvider>
            </LocalizationProvider>
        </CalendarPropsContext.Provider>
    );
};
